import { Link } from "react-router-dom"
import clsx from "clsx"
import { diSanaImgs } from "@/app/utils/constants"
import Slider from "react-slick"
import { useState, useRef } from "react"
import DefaultLayout from "@/layouts/Default"
import { useGlobalContext } from "@/global/GlobalContext"
import { LargerNextArrowBtn, LargerPrevArrowBtn } from "@/components/slider/Buttons"
import HeroSlider from "@/components/slider/HeroSlider"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
import Cookies from "js-cookie"

const DiSana = () => {
  const { categories, onReqDiSana } = useGlobalContext()
  const [imgIndex, setImgIndex] = useState(0)
  const layoutRef = useRef()
  const settingsMob = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        // this breakpoints starts from the initial value to less
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  };

  const settingsDesk = {
    className: "center slider variable-width",
    centerMode: true,
    centerPadding: "0px",
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: false,
    beforeChange: (current, next) => {
      setImgIndex(next)
    },

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    fade: true,
  };

  const handleCategoryId = (id) => {
    Cookies.set("categoryId", id)
  }

  return (
    <DefaultLayout ref={layoutRef} hasDiscoverLink>
      <section id="diSanaCategories" className="py-20">
        {categories.length > 0 &&
          <h2 className="font-agcasmlt uppercase text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-[#95702e] text-center mb-10">Our Products</h2>
        }
        {/* mob view */}
        {onReqDiSana ?
          <ContainerSkeleton custCls="mb-20 sm:hidden" custW="w-full" custH="h-[600px]" />
          :
          categories.length > 0 &&
          <>
            <Slider className="sm:!hidden mb-20" {...settingsMob}>
              {categories && categories.map((s, i) => (
                <div key={i} className="relative mb-6 w-full">
                  <img width="100" src={s.photo} className="w-full bg-cover object-cover h-[600px]" />
                  <div className="p-1 border border-[#95702e] w-[80%] absolute  -bottom-6 left-1/2 -translate-x-1/2">
                    <Link to={s.slug} className="bg-[#95702e] pt-2 font-agcasmlt font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white block text-center">
                      {s.name}
                    </Link>
                  </div>
                </div>
              ))}
            </Slider>
            {/* <p className="text-center text-gray-500 sm:hidden mb-20">No category available.</p> */}
          </>
        }
        {/* laptop view */}
        {onReqDiSana ?
          <div className="hidden md:flex items-center mb-16">
            {Array.from({ length: 3 }, (_, i) => (
              <div key={i} className={clsx("w-full", { "active-skeleton": i == 1, "side-skeleton": i != 1, "leftSlide": i == 0, "rightSlide": i == 2 })}>
                <ContainerSkeleton key={i} custW="w-full" custH="h-full" />
              </div>
            ))}
          </div>
          :
          categories.length > 0 &&
          <>
            <div className="max-sm:hidden mb-8">
              <Slider {...settingsDesk} className="slider--custom-center">
                {categories && categories.map((s, i) => (
                  <div key={i} className={clsx("relative mb-6 slide", {
                    "activeSlide": ((i == imgIndex && categories.length > 3) || (((i - imgIndex == 1) || (i == 0 && imgIndex == 2)) && categories.length == 3)),
                    "leftSlide": (
                      ((i + 1 == imgIndex) ||
                        (i == (categories.length - 1) && parseInt(imgIndex) == 0)) && categories.length > 3) ||
                      (i == imgIndex && categories.length == 3),
                    "rightSlide": (
                      ((i - 1 == imgIndex) ||
                        (i == 1 && parseInt(imgIndex) == 0) ||
                        (i == 0 && parseInt(imgIndex) == (categories.length - 1))) &&
                      categories.length > 3) ||
                      ((imgIndex - i == 1 || (i == 2 && imgIndex == 0)) && categories.length == 3)
                  })}>
                    <img width="100" src={s.photo} loading="lazy" className={clsx("w-full object-cover")} />
                    <div className={clsx("p-1 border border-[#95702e] absolute left-1/2 -translate-x-1/2", {
                      "bottom-1 sm:-bottom-2 lg:bottom-1 w-[60%]": (
                        i != imgIndex && categories.length > 3) || ((i == imgIndex || (imgIndex - i == 1 || (i == 2 && imgIndex == 0))) && categories.length == 3),
                      "-bottom-[54px] w-[80%]": (i == imgIndex && categories.length > 3) ||
                        (((i - imgIndex == 1) || (i == 0 && imgIndex == 2)) && categories.length == 3)
                    })}>
                      <Link to={s.slug} onClick={() => handleCategoryId(s.id)} className={clsx("bg-[#95702e] pt-2 px-2 font-agcasmlt font-light text-white block text-center", {
                        "text-xl sm:text-2xl md:text-3xl lg:text-4xl": (
                          i != imgIndex && categories.length > 3) || ((i == imgIndex || (imgIndex - i == 1 || (i == 2 && imgIndex == 0))) && categories.length == 3), "text-2xl sm:text-3xl md:text-4xl lg:text-5xl": (i == imgIndex && categories.length > 3) ||
                            (((i - imgIndex == 1) || (i == 0 && imgIndex == 2)) && categories.length == 3)
                      })}>
                        {s.name}
                      </Link>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
            {/* <p className="text-center text-gray-500 max-sm:hidden mb-8">No category available.</p> */}
          </>
        }
        <p className="font-agcasmlt text-[#6b6059] text-lg sm:text-xl lg:text-2xl font-light text-center w-[70%] mx-auto mb-14">You will experience the best from both the East and the West as they juxtapose beautifully and harmoniously in a universal and timeless high quality products.</p>
        <div className="w-[80%] h-[500px] bg-[url('/src/assets/imgs/di-sana/di-sana-content.jpg')] bg-cover bg-center mb-16 mx-auto"></div>
        <p className="font-agcasmlt text-[#6b6059] text-lg sm:text-xl lg:text-2xl font-light text-center w-[70%] mx-auto mb-16">Each of our product is designed and curated by the internationally known interior designer, Jonathan Rachman, with his Currently Classic aesthetics.</p>
        <div className="mx-auto w-[80%] h-screen">
          <div className="relative">
            <HeroSlider settings={settings2} slides={diSanaImgs.slides} title="di sana" subtitle="our shop & cafe" text1 />
          </div>
        </div>
      </section>
    </DefaultLayout>
  )
}

const PrevArrow = (props) => {
  const { onClick } = props;
  return <LargerPrevArrowBtn onClickBtn={onClick} />
}

const NextArrow = (props) => {
  const { onClick } = props;
  return <LargerNextArrowBtn onClickBtn={onClick} />
}

export default DiSana